'use strict';

if (process.env.NODE_ENV === 'production') {
  module.exports = require('./es/react-hotkeys.production.min.js');
} else {
  module.exports = require('./es/index.js');
}



//////////////////
// WEBPACK FOOTER
// ../react-hotkeys/index.es.js
// module id = 760
// module chunks = 0